@if (pfTitle) {
    <pf-text type="description">{{ pfTitle }}</pf-text>
}
@if (customFilter) {
    <pf-date-picker
        datePickerType="dateRange"
        data-pf-handle="loads-date-custom-filter"
        [control]="dateRangeControl"
        (calendarChanged)="calendarChanged.emit($event)"
        [presetRanges]="presetRanges">
    </pf-date-picker>
}
@if (!customFilter && filterOptions?.length) {
    <pf-filter-group
        [filterOptions]="filterOptions || []"
        data-pf-handle="loads-date-filter"
        (selectedChange)="handleFilterGroupChange($event)"></pf-filter-group>
}
